import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { invoicingAndPaymentsEnabled } from 'constants-ts/featureFlags';

export const usePaymentsFeatureEnabled = () => {
  const appConfig = useSelector((state) => state.appConfig?.data);
  return (
    invoicingAndPaymentsEnabled &&
    Boolean(appConfig?.payments?.enableGeneralInvoicingAndPayments) &&
    Boolean(appConfig?.payments?.enableOnlinePayment)
  );
};

export const useEnableOnlinePayments = (salesAccount) => {
  const isFeatureEnabled = usePaymentsFeatureEnabled();
  return useMemo(() => isFeatureEnabled && salesAccount && salesAccount?.isActive, [salesAccount, isFeatureEnabled]);
};

export const useGeneralInvoicingAndPaymentsEnabled = () => {
  const appConfig = useSelector((state) => state.appConfig?.data);
  return invoicingAndPaymentsEnabled && Boolean(appConfig?.payments?.enableGeneralInvoicingAndPayments);
};
